import React from 'react';

import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Text from 'components/atom/Text/styles';

import { Container } from './styles';

interface ICardMessageProps {
  message: string;
  setTab?: () => void;
}

const CardMessage: React.FC<ICardMessageProps> = ({ message, setTab }) => (
  <Container onClick={() => setTab && setTab()}>
    <Text weight="bold">{message}</Text>

    {setTab && <FontAwesomeIcon icon={faChevronRight} />}
  </Container>
);

export default CardMessage;
